import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { AccountsFeedTable } from "../components/accounts/accountsFeedTable"

export const AccountsPage: FC = () => (
  <UserbotPage title="Аккаунты и сессии">
    <AccountsFeedTable />
  </UserbotPage>
)
